import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-account-dialog',
  templateUrl: './remove-account-dialog.component.html',
  styleUrls: ['./remove-account-dialog.component.scss']
})
export class RemoveAccountDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveAccountDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      email: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
